(function (window, document) {
  'use strict';

  var P = window.Printara;
  if (!P) return;

  var dimensionOptions = [
    { value: 'Print at Dimensions Listed', label: 'Print at Dimensions Listed' },
    { value: 'Scale', label: 'Enlarge from a Known Scale' },
    { value: 'Other', label: 'Other Instructions' }
  ];

  var squareFootageOptions = [
    { value: 'Print As-Is', label: 'Print As-Is' },
    { value: 'Scale', label: 'Enlarge from a Known Scale' },
    { value: 'Other', label: 'Other Instructions' }
  ];

  var notes = {
    'Print at Dimensions Listed':
      'We’ll print the artwork to the width and height entered above.',
    'Print As-Is':
      'We’ll print the artwork at the size contained in the uploaded file. We will not resize it.',
    Scale: '',
    Other: ''
  };

  function init() {
    var printInstructions = document.getElementById('print-instructions');
    var instructionsNote = document.getElementById('print-instructions-note');
    var selectedInstructionLabel = document.querySelector(
      '[data-selected-print-instructions]'
    );
    var scaleSection = document.getElementById('scale');
    var scaleSelect = document.getElementById('scale-select');
    var otherSection = document.getElementById('other');
    var otherInput = document.getElementById('other-txt');
    var calculator = document.querySelector('[data-gk-calc]');

    if (
      !printInstructions ||
      !instructionsNote ||
      !scaleSection ||
      !scaleSelect ||
      !otherSection ||
      !otherInput
    ) {
      return;
    }

    function getMode() {
      if (!calculator) return 'dimensions';

      var squareTab = calculator.querySelector(
        '.gk-tab[data-tab="squareFootage"]'
      );

      return (
        squareTab &&
        (
          squareTab.classList.contains('is-active') ||
          squareTab.getAttribute('aria-selected') === 'true'
        )
      )
        ? 'squareFootage'
        : 'dimensions';
    }

    function populate(mode) {
      var options =
        mode === 'squareFootage'
          ? squareFootageOptions
          : dimensionOptions;

      var current = printInstructions.value;
      var preserve =
        current === 'Scale' || current === 'Other'
          ? current
          : null;

      printInstructions.innerHTML = '';

      options.forEach(function (option) {
        var element = document.createElement('option');
        element.value = option.value;
        element.textContent = option.label;
        printInstructions.appendChild(element);
      });

      printInstructions.value = preserve || options[0].value;
    }

    function updateFields() {
      var instruction = printInstructions.value;
      var selectedOption =
        printInstructions.options[printInstructions.selectedIndex];

      if (selectedInstructionLabel) {
        selectedInstructionLabel.textContent = selectedOption
          ? selectedOption.textContent.trim()
          : '';
      }

      var showScale = instruction === 'Scale';
      var showOther =
        instruction === 'Other' ||
        (showScale && scaleSelect.value === 'Other');

      scaleSection.hidden = !showScale;
      scaleSelect.disabled = !showScale;
      scaleSelect.required = showScale;

      otherSection.hidden = !showOther;
      otherInput.disabled = !showOther;
      otherInput.required = showOther;

      var note = notes[instruction] || '';
      instructionsNote.textContent = note;
      instructionsNote.hidden = !note;

      if (!showOther) {
        otherInput.value = '';
      }

      P.emit('printara:instructions:update', {
        instruction: instruction,
        showScale: showScale,
        showOther: showOther
      });

      if (P.calculator && P.calculator.updateSubmitButtonState) {
        P.calculator.updateSubmitButtonState();
      }
    }

    function updateMode() {
      populate(getMode());
      updateFields();
    }

    printInstructions.addEventListener('change', updateFields);
    scaleSelect.addEventListener('change', updateFields);

    document.addEventListener('printara:calculator:mode', updateMode);

    updateMode();
  }

  P.util.ready(init);

  document.addEventListener('shopify:section:load', init);
})(window, document);